export var MessageVariantType;
(function (MessageVariantType) {
    MessageVariantType["INFORMATIVE"] = "INFORMATIVE";
    MessageVariantType["WARNING"] = "WARNING";
    MessageVariantType["SUCCESS"] = "SUCCESS";
    MessageVariantType["ERROR"] = "ERROR";
    // Contact Center
    MessageVariantType["CONTACT_CENTER"] = "CONTACT_CENTER";
    MessageVariantType["CONTACT_CENTER_SCRIPT"] = "CONTACT_CENTER_SCRIPT";
})(MessageVariantType || (MessageVariantType = {}));
//# sourceMappingURL=variants.js.map